<template>
	<div>
		<Header></Header>
		<div style="background: #333;position: relative; z-index: 1;" data-interval="3000"
			class="carousel slide" data-ride="carousel">
			 <el-carousel :height="imgHeight+'px'">
			    <el-carousel-item v-for="(item, index) in carousels" :key="index">
						<!-- <img src="@/assets/img/banner.png" style="height: 28rem;" /> -->
						<img :src="item" ref="bannerImg" @load="imgLoad" style="width: 100%;" />
						<!-- <div class="carouse-bg-img" :style="`background:url(${item}) top center`"></div> -->
					</el-carousel-item>
					<!-- <el-carousel-item>
						<img src="@/assets/img/banner2.jpg" style="height: 28rem;" />
					</el-carousel-item> -->
			  </el-carousel>
		</div>
		<div class="container" style="margin-top: 3.75rem;">
			<div class="m-box">
				<h2 class="m-title">公司介绍</h2>
				<!-- <h4>About Us</h4> -->
				<!-- <p>我们是一家专业从事母线系列产品研发、生产、销售和服务一体化的公司</p> -->
			</div>
		</div>

		<div class="container pt-4 pb-4">
			<div class="row">
				<!-- <div class="col-lg-6">
					<img src="@/assets/img/zs.png" />
				</div> -->

				<div v-html="renderHTML(profile.content)"></div>
			</div>
			<!-- <div class="m-num">
				<div>
					<strong>1000</strong><span>万</span>
					<p>注册资金</p>
				</div>
				<div>
					<strong>500</strong><span>+</span>
					<p>合作项目</p>
				</div>
			</div> -->
		</div>
		<div class="pbg">
			<div class="container" style="margin-top: 24px;">
				<div class="m-box">
					<h2 class="m-title">产品中心</h2>
					<!-- <h4>Products</h4>
					<p>我们是一家专业从事母线系列产品研发、生产、销售和服务一体化的公司</p> -->
				</div>
				<div class="products-box">
					<ul>
						<li :class="index==selectIndex&&'active'" v-for="(item, index) in categorys" @click="onSelectProductMenu(index)" :key="index">{{item.categoryName}}</li>
					</ul>
					<div class="pdlist">
						<div class="product-list">
							<div class="product-item" v-for="(item2, index) in selectData" @click="handleShowDetail(item2)" :key="index">
								<div>
									<div>
										<img :src="item2.image" />
									</div>
									<p>{{item2.name}}</p>
									<!-- <img :src="`@/assets/img/product/${item2.name}/${item2.path}`" /> -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
<!--		<div class="container">-->
<!--			<div class="sel-why" style="padding: 2rem 0px;">-->
<!--				<h2 style="font-size: 2rem; text-align: center;">选择<strong>亿德</strong>电气的3大理由</h2>-->
<!--				&lt;!&ndash; <h3></h3> &ndash;&gt;-->
<!--				<h6>优质可靠的产品和设备体贴入微的服务</h6>-->
<!--				<div class="why-me-box">-->
<!--					<div class="why-me-item">-->
<!--						<div class="item-top">-->
<!--							<h2><img src="../assets/img/sel01.png" />诚信经营品质保证</h2>-->
<!--							<p>-->
<!--								专业从事母线系列产品研发、生产、销售和服务一体化的公司提供安全、可靠、高效的母线配电产品及整体解决方案产品型号齐全，满足你所有的需求。-->
<!--							</p>-->
<!--						</div>-->
<!--						<img src="../assets/img/sel01_img.png" />-->
<!--					</div>-->
<!--					<div class="why-me-item">-->
<!--						<div class="item-top">-->
<!--							<h2><img src="../assets/img/sel02.png" />强大的设计团队</h2>-->
<!--							<p>拥有专业技术科研团队，具有丰富的科研经验可根据客户的需求设计研发各类空气型，密集型，低压过桥，高压过桥母线槽可提供安全、可靠、高效的母线配电产品及整体解决方案。 </p>-->
<!--						</div>-->
<!--						<img src="../assets/img/sel02_img.png" />-->
<!--					</div>-->
<!--					<div class="why-me-item">-->
<!--						<div class="item-top">-->
<!--							<h2><img src="../assets/img/sel03.png" />雄厚的技术实力</h2>-->
<!--							<p>多年的行业经验沉淀，专业的绝绿材料生产商采用国外先进的生产设备、加工工艺、品质管理和完善的服务体系产品质量可靠，性能稳定，并一次性通过国家3C认证。</p>-->
<!--						</div>-->
<!--						<img src="../assets/img/sel03_img.png" />-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
<!--		</div>-->

		<!-- <div class="container pt-4 pb-4">
			<div class="row">
				<div class="col-lg-6">
					<div class="why-me-box">
						<h2>强大的设计团队，满足各种定制需求</h2>
						<p>拥有专业技术科研团队，具有丰富的科研经验</p>
						<p>可根据客户的需求设计研发各类空气型，密集型，低压过桥，高压过桥母线槽</p>
						<p>可提供安全、可靠、高效的母线配电产品及整体解决方案</p>
					</div>
				</div>
				<div class="col-lg-6">
					<img src="@/assets/img/piz1.png" />
				</div>
			</div>
		</div> -->

		<!-- <div class="container pt-4 pb-4">
			<div class="row">
				<div class="col-lg-6">
					<img src="@/assets/img/piz3.png" />
				</div>
				<div class="col-lg-6">
					<div class="why-me-box">
						<h2>雄厚的技术实力，成就优质的产品</h2>
						<p>多年的行业经验沉淀，专业的绝绿材料生产商</p>
						<p>采用国外先进的生产设备、加工工艺、品质管理和完善的服务体系</p>
						<p>产品质量可靠，性能稳定，并一次性通过国家3C认证</p>
					</div>
				</div>
			</div>
		</div> -->

		<!-- <div class="container pt-4 pb-4">
			<div class="row">
				<div class="col-lg-6">
					<div class="why-me-box">
						<h2>完善的售后服务，让您省时省心</h2>
						<p>快速响应，全程服务，一对一服务。</p>
						<p>目前我们在多地建立优秀专业的销售跟售后服务队伍，为客户提供优质高标准的服务。</p>
						<p>我们的产品得到许多客户的认可，客户满意度98%以上！</p>
						<p style="margin-top: 0.625rem;">全国服务热线：<strong>13272722088</strong></p>
					</div>
				</div>
				<div class="col-lg-6"><img src="@/assets/img/piz2.png" /></div>
			</div>
		</div> -->


		<div style="background: #fff; padding: 1.25rem;">
			<div class="container" style="margin-top: 24px;">
				<div class="m-box">
					<h2 class="m-title">项目案例</h2>
				<!-- 	<h4>CASE</h4>
					<p>我们是一家专业从事母线系列产品研发、生产、销售和服务一体化的公司</p> -->
				</div>
				<div class="case-box" style="position: relative; width:100%; padding: 1.875rem; display: flex; align-items: stretch; min-height: 200px;" v-loading="caseloading">
					<div class="case-btn prev" @click="handleCasePrev"><i class="el-icon-arrow-left"></i></div>
					<div class="case-item flex1" v-for="(item,index) in caseList" :key="index" @click="handleDetail(item)">
						<img :src="item.image" />
						<p>{{item.title}}</p>
					</div>
					<div class="case-btn next" @click="handleCaseNext"><i class="el-icon-arrow-right"></i></div>
				</div>
			</div>
		</div>

		<!-- <div style="background: #fff; padding: 1.25rem;">
			<div class="container" style="margin-top: 24px;">
				<div class="m-box">
					<h2 class="m-title" style="width: 20rem;">企业合作伙伴 <span style="font-size: 1rem; font-weight: normal; color: #172130;">(部分展示)</span></h2>
					<p>我们是一家专业从事母线系列产品研发、生产、销售和服务一体化的公司</p>
					<p>商伴同立 价值致远</p>
				</div>
				<img  src="../assets/img/customer.png" />
			</div>
		</div> -->

		<Footer></Footer>

	</div>

</template>

<script>
	import Header from '@/components/Header.vue'
	import Footer from '@/components/Footer.vue'
	// import datas from '../products.json'
	// var jsonData = require('../products.json');
	export default {
		name: 'index',
		components: {
			// HelloWorld
			Header,
			Footer
		},
		data() {
			return {
				// products: jsonData.data,
				selectIndex: 0,
				// selectData: jsonData.data[0],
				profile: {},
				categorys: [],
				carousels: [],
				products: [],
				selectData: [],
				caseList: [],
				imgHeight: 400,
				caseParams: {
					pageNumber: 1,
					pageSize: 5
				},
				caseloading: false
			}
		},
		metaInfo() {
			return {
				title: '首页',
				meta: [{
					name: 'keywords',
					content: 'keyword,测试一下'
				}]
			}
		},
		methods: {
			imgLoad() {
				this.$nextTick(() => {
					if(this.$refs.bannerImg) {
						this.imgHeight = this.$refs.bannerImg[0].height
					}
				})
			},
			async getData() {
				const res = await this.$post('/main');
				// console.log(res);
				this.profile = res.data.data.profile;
				this.categorys = res.data.data.categorys;
				this.carousels = res.data.data.carousels;
				this.onSelectProductMenu(0)
			},
			async getProduct(categoryId) {
				const res = await this.$post('/product/findPage', {
					categoryId,
					pageSize: 8,
					pageNumber: 1
				});
				// console.log(res);
				this.selectData = res.data.data.records;
			},
			renderStyle(it) {
				// var url = require(`@/assets/img/product/${this.selectId}/${it.path}`);
				return `background: url(${it.image}) no-repeat center #fff; `
			},
			renderHTML(content) {
				return content;
			},
			onSelectProductMenu(index) {
				this.selectIndex = index;
				this.getProduct(this.categorys[index].categoryId);
				// this.selectData = this.car.data[id];
			},
			handleShowDetail(item) {
				this.$router.push({
					path: '/product-detail',
					query: {
						id: item.id
					}
				})
			},
			handleDetail(item) {
				this.$router.push({
					path: '/case-detail',
					query: {
						id: item.id
					}
				})
			},
			async getCase() {
				this.caseloading = true;
				const res = await this.$post('/case/findPage', this.caseParams);
				// console.log(res);
				this.caseList = res.data.data.records;
				this.caseloading = false;
			},
			handleCasePrev() {
				if(this.caseParams.pageNumber == 1) {
					return;
				}
				this.caseParams.pageNumber -= 1;
				this.getCase();
			},
			handleCaseNext() {
				this.caseParams.pageNumber += 1;
				this.getCase();
			},
		},
		mounted() {
			this.getData();
			this.getCase();
			document.title = '首页'
			this.imgLoad();
			window.addEventListener('resize', () => {
				this.imgLoad()
			})
		}
	}
</script>
<style>
	.case-btn {
		height: 2rem;
		width: 2rem;
		border: 1px solid #eee;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #ccc;
		font-size: 1rem;
		cursor: pointer;
		/* margin-top: 21px; */
		position: absolute;
		border-radius: 50%;
		top: 118px;
	}
	.case-btn:hover {
		background: rgba(0, 0, 0, 0.5);
	}
	.case-btn.prev {
		left: 0px;
	}
	.case-btn.next {
		right: 0px;
	}
	.flex1 {
		width: 100%;
	}
</style>
